import React, { useState } from 'react';
import type { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { useRequest } from 'ahooks';
import Layout from '@/layouts';
import { getProductList, getRecommendProductList } from '@/services/product';
import { Product, RecommendProduct } from '@/interface/product';
import Footer from '@/components/footer';
import HeaderBanner from './components/HeaderBanner';
import RecommendProductCard from './components/RecommendProductCard';
import ProductCard from './components/ProductCard';
import styles from './index.module.scss';

const pageSize = 10;
export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.setHeader('Cache-Control', 'public, s-maxage=59, stale-while-revalidate=119');
  try {
    const { data: recommendProductListRes } = await getRecommendProductList({
      pageIndex: 1,
      pageSize: 3,
    });
    const { data: productListRes } = await getProductList({
      pageIndex: 1,
      pageSize,
    });
    // console.log(recommendProductListRes);
    // console.log(productListRes);
    return {
      props: {
        recommendProductList: recommendProductListRes.list || [],
        initialPoductList: productListRes.list || [],
        productListTotal: productListRes.total,
      },
    };
  } catch (e) {
    const recommendProductList: RecommendProduct[] = [];
    const initialPoductList: Product[] = [];
    return {
      props: {
        recommendProductList,
        initialPoductList,
        productListTotal: 0,
      },
    };
  }
};

function CbndataBoxPage({
  recommendProductList,
  initialPoductList,
  productListTotal,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const [productList, setProductList] = useState(initialPoductList);
  const { loadingMore, loadMore, noMore } = useRequest(
    d => {
      // Server端获取第一页内容，Client端从第二页开始获取内容
      return getProductList({ pageIndex: (d?.list.length || 0) / pageSize + 2, pageSize });
    },
    {
      manual: true,
      initialData: { list: productList, total: productListTotal },
      formatResult(res) {
        return {
          list: res.data.list,
          total: res.data.total,
        };
      },
      onSuccess(res) {
        res.list?.length && setProductList(productList.concat(res.list));
      },
      loadMore: true,
      isNoMore: d => {
        // 计算是否有更多数据时要加上Server端请求的第一页数据（实际请求数据length小于pageSize也没事，代表在Server端第一页已请求完所有数据）
        return d ? d.list.length + pageSize >= d.total : false;
      },
    }
  );
  return (
    <Layout
      title="Martech企服商店-企服点评平台-SaaS应用商店 | CBNData"
      description="第一财经商业数据中心（CBNData）隶属于上海文化广播影视集团（SMG），是国内领先的消费研究机构及数字化增长服务商。CBNDataBox是专业的Martech企服应用商店，围绕企业内营销流程的需求场景，为消费行业的营销&运营人员整合优质的Martech企服工具。"
      keyword="企业服务,企业服务工具,CBNData企服商店,公司点评,企服点评,SaaS商店,应用商店,大数据,SaaS服务,客户管理,营销数据,市场营销,创业服务,营销决策,管理工具"
      isShowNavBar
      FooterComponent={Footer}
      // isFrapMain
    >
      <HeaderBanner />
      {!!recommendProductList.length && (
        <section className={styles.recommendProductList}>
          {recommendProductList.map(item => (
            <RecommendProductCard
              className={styles.recommendProductCard}
              key={item.boxRecommendProductId}
              boxProductId={item.boxProductId}
              productName={item.productName}
              productLogo={item.productLogo}
              summary={item.summary}
              tagType={item.angleMark}
            />
          ))}
        </section>
      )}
      <section className={styles.productListSection}>
        <h2 className={styles.title}>全部推荐</h2>
        <div className={styles.productList}>
          {productList.map(item => (
            <ProductCard
              className={styles.productCard}
              key={item.boxProductId}
              boxProductId={item.boxProductId}
              productName={item.productName}
              productLogo={item.productLogo}
              summary={item.summary}
              tagType={item.angleMark}
            />
          ))}
        </div>
        {!noMore && (
          <button className={styles.loadMoreBtn} disabled={loadingMore} onClick={loadMore}>
            加载更多
          </button>
        )}
      </section>
    </Layout>
  );
}

export default CbndataBoxPage;
